var map = {
	"./Career.png": 6751,
	"./Children.png": 7843,
	"./Friends.png": 8946,
	"./Health.png": 1807,
	"./Life.png": 2639,
	"./Parents.png": 9174,
	"./Property.png": 6498,
	"./Siblings.png": 1084,
	"./Spouse.png": 2056,
	"./Travel.png": 6101,
	"./Wealth.png": 6674,
	"./Wellbeing.png": 1768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4613;